import React from 'react';
import jwksClient from 'jwks-client';
import { verify } from 'jsonwebtoken';
import * as msal from '@azure/msal-browser';
import APIClient from '../../Helpers/APIClient';

const msalConfig = {
  auth: {
    clientId: '',
    authority: '',
    knownAuthorities: [],
    redirectUri: `${window.location.origin}${window.location.pathname}`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (process.env.NODE_ENV !== 'production') {
          switch (level) {
            case msal.LogLevel.Error:
              console.error(message);
              return;
            case msal.LogLevel.Info:
              console.info(message);
              return;
            case msal.LogLevel.Verbose:
              console.debug(message);
              return;
            case msal.LogLevel.Warning:
              console.warn(message);
              return;
            default:
              console.log(message);
          }
        }
      },
    },
  },
};

export default class AuthB2C extends React.Component {
  constructor(props) {
    super(props);
    this.localAccountID = process.env.REACT_APP_LOCAL_ACCOUNT_ID;
    this.localJWT = process.env.REACT_APP_LOCAL_JWT;
    this.pathLoginType = process.env.REACT_APP_AUTH_TYPE;
    this.ua = window.navigator.userAgent;
    this.cacheBase = 'pingnation.b2clogin.com';
    this.msie = this.ua.indexOf('MSIE ');
    this.msie11 = this.ua.indexOf('Trident/');
    this.msedge = this.ua.indexOf('Edge/');
    this.isIE = this.msie > 0 || this.msie11 > 0;
    this.isEdge = this.msedge > 0;
    this.signInType = '';
    this.accountId = '';
    this.openIdConfiguration = '';
    this.keysConfiguration = '';
    this.silentRequest = {
      loginHint: this.getLocalAccountID(),
      extraQueryParameters: {
        response_type: 'code+id_token',
      },
      tokenQueryParameters: {
        response_type: 'code+id_token',
      },
    };
    this.loginRequest = {
      scopes: [],
      prompt: 'login',
      extraQueryParameters: {
        response_type: 'code+id_token',
      },
      tokenQueryParameters: {
        response_type: 'code+id_token',
      },
    };
    this.currentToken = false;
    this.checkLoginType();
  }

  checkLoginType = () => {
    APIClient.get(this.pathLoginType, (status, response) => {
      if (status === 200 && response.Type && response.Type.toLowerCase() === 'azureb2c') {
        this.updateConfig(response);
      }
    });
  }

  updateConfig = (data) => {
    msalConfig.auth.clientId = data.ClientId ?? '';
    msalConfig.auth.authority = data.Authority ?? '';
    msalConfig.auth.knownAuthorities = data.KnownAuthorities ?? [];
    this.openIdConfiguration = data.OpenIdConfiguration;
    this.keysConfiguration = data.KeysConfiguration;

    this.verifyHashToken();
  }

  verifyHashToken = () => {
    const hashToken = this.getHashValue();
    const localJWTToken = this.getJWTToken();

    if (hashToken || localJWTToken) {
      const verifiedToken = hashToken || localJWTToken;

      verify(verifiedToken, this.getKey, { algorithms: ['RS256'] }, (err) => {
        if (!err) {
          this.removeLocalStorageItems();
          this.currentToken = verifiedToken;
          this.setLocalStorageItems(this.currentToken);
          this.handleTokenChange(this.currentToken);
        } else {
          this.initiateClient();
        }
      });
    } else {
      this.initiateClient();
    }
  }

  getKey = (header, callback) => {
    const client = jwksClient({
      jwksUri: this.keysConfiguration,
    });

    client.getSigningKey(header.kid, (err, key) => {
      if (!err && key?.publicKey) {
        callback(null, key.publicKey);
      } else {
        this.initiateClient();
      }
    });
  }

  initiateClient = () => {
    this.myMSALObj = new msal.PublicClientApplication(msalConfig);

    this.myMSALObj.handleRedirectPromise().then(this.handleResponse).catch((err) => {
      this.signIn('loginRedirect');
    });
  }

  handleResponse = (resp) => {
    const isInIframe = window.parent !== window;
    if (!isInIframe) {
      if (resp !== null) {
        this.accountId = resp.account.homeAccountId;
        this.getTokenRedirect(this.loginRequest, resp.account);
      } else {
        const checkCurrentAccounts = this.myMSALObj.getAllAccounts();
        if (checkCurrentAccounts.length > 0) {
          this.accountId = checkCurrentAccounts[0].homeAccountId;
          this.getTokenRedirect(this.loginRequest, checkCurrentAccounts[0]);
        } else {
          this.myMSALObj.ssoSilent(this.silentRequest).then(() => {
            const currentAccounts = this.myMSALObj.getAllAccounts();
            this.accountId = currentAccounts[0].homeAccountId;
            this.getTokenRedirect(this.loginRequest, currentAccounts[0]);
          }).catch((c) => {
            this.removeLocalStorageItems();
            this.signIn('loginRedirect');
          });
        }
      }
    }
  }

  async signIn(method) {
    this.signInType = this.isIE ? 'loginRedirect' : method;
    if (this.signInType === 'loginPopup') {
      return this.myMSALObj.loginPopup(this.loginRequest)
        .then(this.handleResponse);
    }

    return this.myMSALObj.loginRedirect(this.loginRequest);
  }

  getLocalAccountID = () => {
    let accountId = '';
    Object.keys(localStorage).forEach((key) => {
      try {
        const values = JSON.parse(localStorage[key]);
        if (values?.homeAccountId) {
          accountId = values?.homeAccountId;
        }
        return true;
      } catch (e) {
        return false;
      }
    });

    return accountId;
  }

  getHashValue = () => {
    let hashIDValue = false;
    if (window.location.hash !== '') {
      const hashArray = window.location.hash.split('#');
      hashArray.forEach((hashItem) => {
        if (hashItem?.indexOf('state=') > -1) {
          hashIDValue = hashItem.replace('state=', '');
        }
      });
    }

    return hashIDValue;
  }

  getJWTToken = () => {
    let jwtToken = false;
    Object.keys(localStorage).forEach((key) => {
      try {
        const values = JSON.parse(localStorage[key]);
        if (values?.secret && values?.credentialType?.toString().toLowerCase() === 'idtoken') {
          jwtToken = values.secret;
        }
      } catch (e) {
        jwtToken = false;
      }
    });

    return jwtToken;
  }

  removeLocalStorageItems = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.indexOf('pingnation.b2clogin.com') > -1) {
        localStorage.removeItem(key);
      }
    });
  }

  setLocalStorageItems = (token) => {
    const localKey = `${Math.random().toString(36)}${this.cacheBase}`;
    const tokenObj = { credentialType: 'idtoken', secret: token };
    localStorage.setItem(localKey, JSON.stringify(tokenObj));
    window.history.replaceState(null, null, ' ');
  }

  async getTokenRedirect(request, account) {
    request.account = account;
    try {
      return await this.myMSALObj.acquireTokenSilent(request)
        .then((response) => {
          if (response && response.idToken) {
            this.currentToken = response.idToken;
            this.handleTokenChange(this.currentToken);
          }
        }).catch(async (error) => {
          if (error instanceof msal.InteractionRequiredAuthError) {
            this.myMSALObj.acquireTokenRedirect(request);
          } else {
            this.signIn('loginRedirect');
          }
        });
    } catch (error) {
      return error;
    }
  }

  handleTokenChange = (token) => {
    this.props.handleTokenChange(token);
  }

  render() {
    return this.state;
  }
}
